import React from "react";
import { DateField, SimpleShowLayout } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { Labeled, TextField } from "react-admin";
import { settings } from "app";
import RoomField from "server/components/Fields/RoomField";
import { SectionTitle } from "features/SectionTitle";

const SessionExamSlots = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <>
      <SectionTitle
        title="Време и място на провеждане"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={2}
          sx={{ ...(isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox) }}
        >
          <>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Зала">
                <RoomField source="roomId" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Дата">
                <DateField
                  source="date"
                  locales="bg-BG"
                />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Начало">
                <TextField source="startTime" />
              </Labeled>
            </Grid>
            <Grid
              item
              xs={12}
              md={3}
            >
              <Labeled label="Край">
                <TextField source="endTime" />
              </Labeled>
            </Grid>
          </>
        </Grid>
      </SimpleShowLayout>
    </>
  );
};

export default SessionExamSlots;
